<mat-form-field appearance="outline" fxFlex="0 0 100%">
  <mat-label >{{ label }}</mat-label>
  <mat-select multiple [formControl]="selectElement">

    @if (withSelectAll) {
      <mat-checkbox class="mat-option" color="primary"
        [checked]="isChecked"
        [indeterminate]="isIndeterminate"
        (change)="toggleAllElements($event.checked)"
        >
        {{ 'COMMON.MULTI_SELECT.SELECT_ALL' | translate }}
      </mat-checkbox>
    }

    @if (sortKey) {
      @for (item of availableElements | orderByKey: sortKey; track item; let i = $index) {
        <mat-option [value]="item">
          {{ displayWith ? displayWith(item, i) : item }}
        </mat-option>
      }
    } @else {
      @for (item of availableElements | orderByKey: sortKey; track item; let i = $index) {
        <mat-option [value]="item">
          {{ displayWith ? displayWith(item, i) : item }}
        </mat-option>
      }
    }

  </mat-select>
</mat-form-field>



